import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store, loadStore, persistStore } from "store";
var DeviceListView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceListView, _super);
    function DeviceListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingStore = true;
        _this.devicesNearby = null;
        return _this;
    }
    Object.defineProperty(DeviceListView.prototype, "devices", {
        get: function () { return store.devices; },
        enumerable: true,
        configurable: true
    });
    DeviceListView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistStore();
                        return [4 /*yield*/, loadStore()];
                    case 1:
                        _a.sent();
                        this.loadingStore = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceListView = tslib_1.__decorate([
        Component
    ], DeviceListView);
    return DeviceListView;
}(Vue));
export default DeviceListView;
